import AddPalmNetwork from "./components/AddPalmNetwork";
import AddCustomTokens from "./components/AddCustomTokens";
import { IConfigureStep } from "./types";

const steps: Array<IConfigureStep> = [
  {
    title: "Add the Palm Network",
    description: `First, add the Palm Network to your wallet automatically by clicking the button below. 
      Click "Continue" to proceed to the next step.`,
    step: 1,
    buttonGoBack: false,
    buttonNext: true,
    buttonNextLabel: "Continue",
    StepComponent: AddPalmNetwork,
  },
  {
    title: "Add Custom Tokens",
    description: `This steps adds the DAI stablecoin token used on the Palm network to your wallet automatically. 
      If you have already added the token, check “I have added the DAI token” to finish up.`,
    step: 2,
    buttonGoBack: true,
    buttonGoBackLabel: "Go Back",
    buttonNext: true,
    buttonNextLabel: "I have configured my wallet",
    StepComponent: AddCustomTokens,
  },
];

export default steps;
